<!-- 学生注册 -->
<template>
  <div class="nucleicAcidTestMain">
    <van-nav-bar title="修改学生信息" left-arrow fixed @click-left="btnleft" />
    <div class="main">
      <van-form @submit="save">
        <div class="formmain">
          <div class="group">
            <van-cell-group v-for="(field, index) in fieldList" :key="index">
              <!-- 年级下拉 -->
              <div
                v-if="field.fieldName == 'grade'"
                :class="[field.isNullable == '1' ? 'isRecessary' : '']"
              >
                <van-field
                  readonly
                  input-align="right"
                  clickable
                  name="picker"
                  :value="saveBody.grade"
                  :label="field.showName"
                  :placeholder="'点击选择' + field.showName"
                  @click="showPickerOne = true"
                  :rules="ruleFunction(field)"
                />
                <van-popup v-model="showPickerOne" position="bottom">
                  <van-picker
                    show-toolbar
                    :columns="gradeList"
                    @confirm="onConfirmOne"
                    @cancel="showPickerOne = false"
                  />
                </van-popup>
              </div>
              <!-- 班级下拉 -->
              <div
                v-else-if="field.fieldName == 'clazz'"
                :class="[field.isNullable == '1' ? 'isRecessary' : '']"
              >
                <van-field
                  input-align="right"
                  :class="[field.isNullable == '1' ? 'isRecessary' : '']"
                  readonly
                  clickable
                  name="picker"
                  :value="className"
                  :label="field.showName"
                  :placeholder="'点击选择' + field.showName"
                  @click="showPickerTwo = true"
                  :rules="ruleFunction(field)"
                />
                <van-popup v-model="showPickerTwo" position="bottom">
                  <van-picker
                    show-toolbar
                    :columns="clazzList"
                    @confirm="onConfirmTwo"
                    @cancel="showPickerTwo = false"
                  />
                </van-popup>
              </div>

              <!-- 暂时无用字符串 -->
              <div
                v-else-if="
                  field.fieldType == '0' && field.fieldName != 'idCard'
                "
                :class="[field.isNullable == '1' ? 'isRecessary' : '']"
              >
                <van-field
                  input-align="right"
                  v-model="saveBody[field.fieldName]"
                  :name="field.fieldName"
                  :label="field.showName"
                  :placeholder="`请输入` + field.showName"
                  :rules="ruleFunction(field)"
                  :disabled="defaultD[field.fieldName] ? true : false"
                />
              </div>
              <!-- 暂时无用字符串 -->
              <div
                v-else-if="
                  field.fieldType == '0' && field.fieldName == 'idCard'
                "
                :class="[field.isNullable == '1' ? 'isRecessary' : '']"
              >
                <van-field
                  input-align="right"
                  v-model="saveBody[field.fieldName]"
                  :name="field.fieldName"
                  :label="field.showName"
                  :placeholder="`请输入` + field.showName"
                  :rules="idRule"
                  @blur="inputChange(field)"
                  :disabled="defaultD[field.fieldName] ? true : false"
                />
              </div>
              <!-- 日期 -->
              <div v-else-if="field.fieldType == '3'">
                <van-field
                  input-align="right"
                  readonly
                  clickable
                  name="picker"
                  :value="saveBody[field.fieldName]"
                  :label="field.showName"
                  :placeholder="'点击选择' + field.showName"
                  @click="changeDate(field)"
                  :rules="ruleFunction(field)"
                  :disabled="defaultD[field.fieldName] ? true : false"
                />
              </div>

              <!-- 数据字典下拉和自定义下拉 || 年份-->
              <div
                v-else-if="
                  field.fieldType == '2' ||
                  field.fieldType == '7' ||
                  field.fieldType == '6'
                "
                :class="[field.isNullable == '1' ? 'isRecessary' : '']"
              >
                <van-field
                  input-align="right"
                  :value="saveBody[field.fieldName + 'Name']"
                  readonly
                  :label="field.showName"
                  :placeholder="`点击选择` + field.showName"
                  @click="pickerClick(field)"
                  :disabled="defaultD[field.fieldName + 'Name'] ? true : false"
                  :rules="ruleFunction(field)"
                />
                <van-popup v-model="show" position="bottom">
                  <van-picker
                    :columns="selectOptions"
                    show-toolbar
                    @cancel="show = !show"
                    @confirm="onConfirmThree"
                    :default-index="defaultIndex"
                  />
                </van-popup>
              </div>

              <!-- 日期时间 -->
              <div v-else-if="field.fieldType == '4'">
                <van-field
                  input-align="right"
                  readonly
                  clickable
                  name="picker"
                  :value="saveBody[field.fieldName]"
                  :label="field.showName"
                  :placeholder="'点击选择' + field.showName"
                  @click="changeDateTime(field)"
                  :rules="ruleFunction(field)"
                  :disabled="defaultD[field.fieldName] ? true : false"
                />
              </div>

              <div v-else>
                <van-field
                  :class="[field.isNullable == '1' ? 'isRecessary' : '']"
                  input-align="right"
                  v-model="saveBody[field.fieldName]"
                  :name="field.fieldName"
                  :label="field.showName"
                  :placeholder="`请输入` + field.showName"
                  :rules="ruleFunction(field)"
                  :disabled="defaultD[field.fieldName] ? true : false"
                />
              </div>
            </van-cell-group>
          </div>
        </div>
        <div class="btnBox">
          <van-button block class="btn" type="info" native-type="submit" :disabled="disabledBtn">
            确认修改
            <img class="blueSha" src="../../assets/img/blueshadow.png" alt />
          </van-button>
        </div>
      </van-form>
      <van-calendar
        ref="Calendar"
        v-model="dateTimeShow"
        :min-date="minDate"
        @confirm="onConfirmDate"
        :formatter="formatter"
        color="#1989fa"
        class="dayDemo"
      />
      <van-popup v-model="dateShow" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          title="选择完整时间"
          @confirm="onConfirmDateTime"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import selectPicker from "@/components/selectPicker"
import { Toast, Dialog } from "vant"
import { publicEncrypt, formatterDate, savePrivacy } from "@/utils/common"
import { isEmpty } from "../../utils/common"

import calendar from "@/utils/calendar.js"
var da = null
export default {
  name: "register",
  components: {
    selectPicker
  },
  data: function () {
    return {
      showRegSuc: false, // 注册成功的展示弹框
      conRegSuc: "",
      actionSuc: null,
      actionErr: "", // 错误提示操作
      action: "", // 确认框提示操作
      actionCon: "", // 暂存数据
      showConfirm: false,
      confirmMsg: "",
      showErr: false,
      errCon: "",
      vde: "",
      disabledBtn: false,
      currentDate: new Date(),
      field: {},
      dateShow: false,
      dateTimeShow: false,
      selectShow: false,
      showPickerOne: false,
      showPickerTwo: false,
      show: false,
      defaultD: {},
      saveBody: {
        deptId: "",
        name: "",
        idCard: "",
        phone: "",
        grade: "",
        clazz: "",
        studentId: "",
        schoolYear: new Date().getFullYear() + "",
        sex: "",
        dateOfBirth: "",
        nativePlace: "",
        nationality: "",
        address: "",
        campus: "",
        kz1: "",
        kz2: "",
        kz3: "",
        kz4: "",
        kz5: "",
        kz6: "",
        kz7: "",
        kz8: "",
        kz9: "",
        kz10: ""
      },
      deptName: "", // 选中单位名称
      fieldList: [], //学生配置字段列表
      gradeList: [], //年级列表
      className: "",
      clazzList: [], //班级列表
      yearList: [], // 入学年度列表
      //是否显示弹出层
      showPickerCollect: {
        xxShow: false
      },
      //全部动态数组
      listCollect: {},
      minDate: new Date(1900, 1, 1),
      selectOptions: [],
      defaultIndex: 0,
      details: [],
      showD: false,
      idRule: [
        {
          required: true,
          message: "",
          trigger: "blur"
        }
      ],
      stuId: []
    }
  },
  watch: {
    saveBody: {
      handler(val) {
        if (val.idType) {
          if (val.idType == "01") {
            this.idRule = [
              {
                required: true,
                message: "",
                trigger: "blur"
              },
              {
                pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                message: "证件号码格式有误",
                trigger: "blur"
              }
            ]
          } else {
            this.idRule = [
              {
                required: true,
                message: "",
                trigger: "blur"
              }
            ]
          }
        } else {
          this.idRule = [
            {
              required: true,
              message: "",
              trigger: "blur"
            },
            {
              pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
              message: "证件号码格式有误",
              trigger: "blur"
            }
          ]
        }
        if (val.idCard) {
        }
      },
      deep: true
    }
  },
  async created() {
    this.vde = this.$route.query.vde
    let { deptId, stuId } = this.$route.query

    if (deptId === undefined) {
      Toast.clear()
      this.$CDialog({
        confirmBtnText: "确认",
        title: "提示",
        message: res.data.message,
        status: "2",
        textSize: "12"
      }).then(() => {
        //返回上一页
        this.$router.go(-1)
      })
    } else {
      this.deptId = deptId
      this.stuId = stuId
      this.yearList = this.getYearArray()
      this.saveBody.deptId = this.$route.query.deptId
      await this.getFieldList()
    }
    setTimeout(() => {
      this.getDetailsMsg(stuId)
    }, 200)
  },
  methods: {
    getDetailsMsg(stuId) {
      this.request({
        baseURL: process.env.VUE_APP_BASE_URL,
        url: "/prepaid/getMsgAndField",
        method: "post",
        // 这里使用 params进行传参, 而不是使用 data
        params: { stuId }
      }).then((res) => {
        let result = res.data.result
        delete result.showFieldList
        this.saveBody = result
        this.fieldList.map((item) => {
          if (
            (item.fieldType == "2" || item.fieldType == "7") &&
            item.fieldName != "clazz"
          ) {
            if (item.options && result[item.fieldName]) {
              let obj = item.options.filter(
                (f) => f.value == result[item.fieldName]
              )
              this.saveBody[item.fieldName + "Name"] = obj[0].label
            }
          }
          if (item.fieldType == "6" && item.fieldName == "schoolYear") {
            this.saveBody[item.fieldName + "Name"] = result[item.fieldName]
          }
          // 判断如果是班级，就单独请求班级数据
          if (item.fieldType == "2" && item.fieldName == "clazz") {
            this.request({
              url: "/schoolConfig/listClassByDeptIdGrade",
              method: "get",
              params: { deptId: this.saveBody.deptId, grade: result.grade }
            }).then((res) => {
              this.clazzList = res.data.result
              this.clazzList.forEach((item) => {
                item.text = item.clazz
              })
              let obj = this.clazzList.filter((f) => {
                return f.uId == result[item.fieldName]
              })
              this.className = obj[0].text
            })
          }
        })
      })
    },
    inputChange({ fieldName }) {
      if (fieldName == "idCard") {
        if (
          this.saveBody.idType == "01" ||
          this.saveBody.idType == "" ||
          this.saveBody.idType == undefined
        ) {
          var reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/
          const idCard = this.saveBody.idCard
          if (reg.test(idCard)) {
            if (idCard.length == 18) {
              this.saveBody.dateOfBirth =
                idCard.substring(6, 10) +
                "-" +
                idCard.substring(10, 12) +
                "-" +
                idCard.substring(12, 14)
              if (idCard.charAt(16) % 2 == 0) {
                this.saveBody.sex = "1"
                this.saveBody.sexName = "女"
              } else {
                this.saveBody.sex = "0"
                this.saveBody.sexName = "男"
              }
            } else if (idCard.length == 15) {
              if (idCard.charAt(14) % 2 == 0) {
                this.saveBody.sex = "1"
                this.saveBody.sexName = "女"
              } else {
                this.saveBody.sex = "0"
                this.saveBody.sexName = "男"
              }
            } else {
              this.saveBody.sex = ""
              this.saveBody.sexName = ""
            }
          } else {
            this.idRule = [
              {
                required: true,
                message: "请输入证件号码",
                trigger: "blur"
              },
              {
                pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                message: "证件号码格式有误",
                trigger: "blur"
              }
            ]
          }
        }
      }
    },
    formatter(day) {
      const _time = new Date(day.date)
      const y = _time.getFullYear()
      const m = _time.getMonth() + 1
      const d = _time.getDate()
      const w = _time.getDay()
      const info = calendar.solar2lunar(y, m, d)
      // https://timor.tech/api/holiday/year/
      //   改变周六周日显示颜色
      if (w === 0 || w === 6) {
        day.className = "weekendRed"
      }
      var mm = m
      mm = m < 10 ? "0" + m : m
      var dd = d
      dd = d < 10 ? "0" + d : d
      // var nowDate = y + "-" + mm + "-" + dd;

      //   优先级:节日>节气>农历
      if (info.festival != null && info.festival != "") {
        day.topInfo = info.festival
        day.className = "weekendRed"
      }
      return day
    },
    btnleft() {
      this.$router.go(-1)
    },
    onConfirmOne(value) {
      this.saveBody.grade = value
      this.showPickerOne = false
      this.clazzList = []
      this.saveBody.clazz = ""
      this.className = ""
      for (var i in this.defaultD) {
        this.saveBody[i] = ""
      }
      this.defaultD = {}
      this.getClazz()
    },
    onConfirmTwo(value) {
      if (value) {
        this.className = value.text
        this.saveBody.clazz = value.uId
        this.request({
          url: "/eduClazzDefault/getMsgByUnique",
          method: "get",
          params: {
            deptId: value.deptId,
            clazzId: value.uId
          }
        }).then((res) => {
          if (res.data.code == 1000) {
            for (var i in this.defaultD) {
              this.saveBody[i] = ""
            }
            this.defaultD = {}
            if (res.data.result) {
              Object.keys(res.data.result).forEach((key) => {
                if (res.data.result[key]) {
                  this.$set(this.saveBody, key, res.data.result[key])
                  this.$set(this.defaultD, key, res.data.result[key])
                  this.fieldList.forEach((item) => {
                    if (
                      item.fieldType == "7" ||
                      item.fieldType == "2" ||
                      item.fieldType == "6"
                    ) {
                      if (key == item.fieldName) {
                        item.options.forEach((val) => {
                          if (val.value == this.saveBody[key]) {
                            this.$set(this.saveBody, key + "Name", val.label)
                            this.$set(this.defaultD, key + "Name", val.label)
                          }
                        })
                      }
                    }
                  })
                }
              })
            }
          }
        })
      }
      this.showPickerTwo = false
    },
    onConfirmThree(value) {
      this.show = false
      this.saveBody[this.field.fieldName] = value.value
      this.$set(this.saveBody, this.field.fieldName + "Name", value.text)
    },
    save() {
      for (let i = 0; i < this.fieldList.length; i++) {
        let field = this.fieldList[i]
        let fieldName = field.fieldName
        let fieldType = field.fieldType
        let showName = field.showName
        let isNullable = field.isNullable
        let value = this.saveBody[fieldName]
        if (isNullable == 1 && isEmpty(value)) {
          // this.showErr = true
          // this.errCon = showName + "不能为空"
          this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              textSize: 16,
              message: showName + "不能为空",
            }).then((res) => {
            });
          return
        } else if (
          fieldType == "1" &&
          !isEmpty(value) &&
          !/^[1-9]\d*$/.test(value)
        ) {
          // this.showErr = true
          // this.errCon = field.showName + "请输入正整数"
          this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              textSize: 16,
              message: field.showName + "请输入正整数",
            }).then((res) => {
            });
          return
        } else if (
          fieldType == "5" &&
          !isEmpty(value) &&
          !/^[1-9]\d*\.\d*|0\.\d*[1-9]\d*$/.test(value)
        ) {
          // this.showErr = true
          // this.errCon = field.showName + "请输入正小数"
          this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              textSize: 16,
              message:field.showName + "请输入正小数",
            }).then((res) => {
            });
          return
        } else if (fieldName == "idCard" && !/^[\s\S]{0,19}$/.test(value)) {
          // this.showErr = true
          // this.errCon = field.showName + "长度不大于20"
          this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              textSize: 16,
              message: field.showName + "长度不大于20",
            }).then((res) => {
            });
          return
        }
      }
      let data = JSON.parse(JSON.stringify(this.saveBody))
      data.confirm = "0"
      console.log(data)

      this.request({
        url: "/prepaid/updateStudentBasicData",
        method: "post",
        data
      }).then((res) => {
        if (res.data.code == 1000) {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            message: res.data.message,
            status: "2",
            textSize: "12"
          }).then(() => {
            sessionStorage.setItem(
              "gradeAddClassInfo",
              JSON.stringify({
                stuId: data.uId,
                currentClazz: this.className,
                gradeName: data.grade,
                deptId: data.deptId,
                deptName: data.deptName
              })
            )
            this.$router.push({
              path: "/paymain",
              query: {
                name: data.name,
                idCard: data.idCard,
                vde: localStorage.getItem("vde")
              }
            })
          })
        } else {
          this.$CDialog({
            confirmBtnText: "确认",
            cancelBtnText: "否",
            title: "提示",
            message: res.data.message,
            status: "2",
            textSize: "12"
          }).then(() => {
            data.confirm = "2"
            // 调用确认修改接口
            this.request({
              url: "/prepaid/updateStudentBasicData",
              method: "post",
              data
            }).then((res) => {
              if (res.data.code == 1000) {
                this.$CDialog({
                  confirmBtnText: "确认",
                  title: "提示",
                  message: res.data.message,
                  status: "2",
                  textSize: "12"
                }).then(() => {
                  sessionStorage.setItem(
                    "gradeAddClassInfo",
                    JSON.stringify({
                      stuId: data.uId,
                      currentClazz: this.className,
                      gradeName: data.grade,
                      deptId: data.deptId,
                      deptName: data.deptName
                    })
                  )
                  this.$router.push({
                    path: "/paymain",
                    query: {
                      name: data.name,
                      idCard: data.idCard,
                      vde: localStorage.getItem("vde")
                    }
                  })
                })
              }
            })
          })
        }
      })
    },

    // 新增学生 生成学生应缴费
    createStandardByStu(info, da) {
      this.request({
        url: "/eduPeriodData/createStandardByStu",
        method: "post",
        params: { studentId: info, isH5: 1 }
      }).then((res) => {
        if (res.data.code == 1000) {
          this.showRegSuc = true
          this.conRegSuc = res.data.message
          this.actionSuc = "reg2"
          this.actionCon = {
            result: res.data.result,
            da: da
          }
        } else {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            message: res.data.message,
            status: "2",
            textSize: "12"
          })
        }
      })
    },
    // 页面点击返回
    onClickLeft() {
      this.$router.go(-1)
    },
    // 规则
    ruleFunction(o) {
      let ru = []
      let normalRule = {
        required: true,
        message: "",
        trigger: "blur"
      }
      let noRule = {
        required: false
      }
      //手机号码
      let phoneRule = {
        pattern: /^1\d{10}$/,
        message: o.showName + "格式有误",
        trigger: "blur"
      }

      ru.push(o.isNullable == "1" ? normalRule : noRule)
      if (o.fieldName == "phone" && this.saveBody.phone != "") {
        ru.push(phoneRule)
      }

      if (o.isNullable == "0") {
        ru = []
      }
      return ru
    },
    // 获取年级数据
    getGradeData(id) {
      this.gradeList = []
      this.clazzList = []
      this.request({
        url: "/schoolConfig/listOnlyGradeByDeptId",
        method: "get",
        params: { deptId: id == null ? this.saveBody.deptId : id }
      }).then((res) => {
        if (res.data.code == 1000) {
          this.gradeList = res.data.result
        }
      })
    },
    // 生日选择器确认按钮
    birthConfirm(date) {
      this.dateShow = false
      this.dateTimeShow = false
      this.selectShow = false
      this.showPickerCollect[this.field.fieldName + "ShowPicker"] = false
      this.saveBody[this.field.fieldName] = formatterDate(date.toString())
    },

    // 获取学生配置字段
    getFieldList() {
      return new Promise((resolve) => {
        this.request({
          url: "/education/getEduStudentField",
          method: "get",
          params: { deptId: this.saveBody.deptId }
        }).then((res) => {
          if (res.data.code == 1000) {
            let arr = res.data.result.filter((item) => {
              return item.fieldName != 'expireInvalid' && item.fieldName !='confirmDeadline'
            })
            this.fieldList = arr
            this.getGradeData(res.data.result.deptId)
            this.initSelect()
          } else {
            Toast.clear()
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              message: res.data.message,
              status: "2",
              textSize: "12"
            }).then(() => {
              this.$router.go(-1)
            })
          }
          resolve()
        })
      })
    },
    // 获取班级列表
    getClazz() {
      this.request({
        url: "/schoolConfig/listClassByDeptIdGrade",
        method: "get",
        params: { deptId: this.saveBody.deptId, grade: this.saveBody.grade }
      }).then((res) => {
        if (res.data.code == 1000) {
          this.clazzList = res.data.result
          this.clazzList.forEach((item) => {
            item.text = item.clazz
          })
        } else {
          Toast.clear()
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            message: res.data.message,
            status: "2",
            textSize: "12"
          })
        }
      })
    },
    // 获取年份数组
    getYearArray() {
      const date = new Date()
      const currentYear = date.getFullYear() + 10
      const yearArray = []
      // 入学年度，最多录入当年的
      const lastYear = currentYear
      for (let i = lastYear; i >= 1900; i--) {
        let obj = {
          text: i,
          value: i,
          label: i
        }
        yearArray.push(obj)
      }
      return yearArray
    },
    // 重置表单
    resetSaveBody() {
      this.saveBody = {
        deptId: this.saveBody.deptId,
        name: "",
        idCard: "",
        phone: "",
        grade: "",
        clazz: "",
        studentId: "",
        schoolYear: new Date().getFullYear() + "",
        sex: "",
        dateOfBirth: "",
        nativePlace: "",
        nationality: "",
        address: "",
        campus: ""
      }
    },
    // 获取资金性质
    getCapitalProperty() {
      return new Promise((resolve) => {
        this.request({
          url:
            "/capitalDeptConfig/listCapitalPropertyExt/" +
            localStorage.getItem("vde"),
          method: "get"
        }).then((res) => {
          if (res.data.code == 1000) {
            resolve(res.data.result)
          }
        })
      })
    },
    // 初始化下拉选择（数据字典和自定义下拉）
    initSelect() {
      this.fieldList.forEach((item) => {
        // 调数据字典
        // console.log(item)
        if (item.fieldType == "2" && !isEmpty(item.dictionary)) {
          if (item.dictionary == "sys_capital_property") {
            this.getCapitalProperty().then((res) => {
              res.forEach((val) => {
                this.$set(val, "text", val.label)
              })
              this.$set(item, "options", res)
            })
            console.log(11)
          } else {
            this.request({
              url: "/system/dictionary/listDictData/" + item.dictionary,
              method: "get"
            }).then((res) => {
              if (res.data.code == 1000) {
                let arr = res.data.result
                if (item.fieldName == "status") {
                  arr.forEach((val) => {
                    if (
                      val.value != "2" &&
                      val.value != "3" &&
                      val.value != "4"
                    ) {
                      this.$set(val, "text", val.label)
                    }
                  })
                  let newArr = arr.filter((it) => {
                    return it.value != "2" && it.value != "3" && it.value != "4"
                  })
                  this.$set(item, "options", newArr)
                  return
                }
                arr.forEach((val) => {
                  this.$set(val, "text", val.label)
                })
                this.$set(item, "options", arr)
              }
            })
          }
        }
        // 调自定义下拉
        if (item.fieldType == "7" && !isEmpty(item.dictionary)) {
          this.request({
            url: "/system/dictDeptData/listDictDeptData",
            method: "get",
            params: { deptId: this.saveBody.deptId, dictType: item.dictionary }
          }).then((res) => {
            if (res.data.code == 1000) {
              let arr = res.data.result
              arr.forEach((val) => {
                this.$set(val, "text", val.label)
              })
              this.$set(item, "options", arr)
            }
          })
        }
        if (item.fieldType == "6") {
          this.$set(item, "options", this.yearList)
        }

        // if (item.fieldType == 2 && item.fieldName == "clazz") {
        //   console.log(this.saveBody)
        // }
      })
    },
    pickerClick(field) {
      if (this.defaultD[field.fieldName + "Name"]) {
        this.show = false
      } else {
        this.show = true
      }

      this.field = field
      this.selectOptions = field.options
      if (this.saveBody[field.fieldName]) {
        this.selectOptions.forEach((item, index) => {
          if (item.value == this.saveBody[field.fieldName]) {
            this.defaultIndex = index
          }
        })
      } else if (
        field.fieldType == "6" &&
        this.saveBody[field.fieldName] == ""
      ) {
        this.selectOptions.forEach((item, index) => {
          if (item.value == new Date().getFullYear()) {
            this.defaultIndex = index
          }
        })
      } else {
        this.defaultIndex = 0
      }
    },

    changeDate(field) {
      if (this.defaultD[field.fieldName]) {
        this.dateTimeShow = false
      } else {
        this.dateTimeShow = true
      }

      this.field = field
    },
    onConfirmDate(date) {
      this.dateTimeShow = false
      this.saveBody[this.field.fieldName] = this.formatDate(date)
    },
    changeDateTime(field) {
      if (this.defaultD[field.fieldName]) {
        this.dateShow = false
      } else {
        this.dateShow = true
      }
      this.field = field
    },
    onConfirmDateTime() {
      this.dateShow = false
      this.saveBody[this.field.fieldName] = this.getNowFormatDate(
        this.currentDate
      )
    },
    formatDate(date) {
      return formatterDate(date)
    },
    getNowFormatDate(date) {
      var seperator1 = "-"
      var seperator2 = ":"
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      var hh = date.getHours()
      var mm = date.getMinutes()
      var ss = date.getSeconds()
      if (month >= 1 && month <= 9) {
        month = "0" + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate
      }
      if (hh >= 0 && hh <= 9) {
        hh = "0" + hh
      }
      if (mm >= 0 && mm <= 9) {
        mm = "0" + mm
      }
      if (ss >= 0 && ss <= 9) {
        ss = "0" + ss
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hh +
        seperator2 +
        mm +
        seperator2 +
        ss
      return currentdate
    }
  }
}
</script>

<style scoped lang='scss'>
.nucleicAcidTestMain {
  ::v-deep .noticeText {

    font-size: 14px;
    color: #464a4c;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 400;
  }
  ::v-deep .ckeckBox {
    span {

      font-size: 14px;
      color: #208fff;
      letter-spacing: 0;
      line-height: 12px;
      font-weight: 700;
    }
  }
  .heade {
    margin-bottom: 5px;
    ::v-deep .van-field__control {
      text-align: center !important;
    }
  }
  ::v-deep .van-nav-bar {
    background: #fff !important;
  }
  ::v-deep .van-nav-bar__left .van-icon {
    font-size: 18px;
    color: #666 !important;
  }
  ::v-deep .van-nav-bar__title {
    font-family: PingFangSC-Semibold;
    font-size: 17px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    font-weight: 600;
  }
  .van-cell-group.van-hairline--top-bottom {
    // margin-bottom: 5px;
  }
  .van-button__text {
    font-size: 18px;
  }
  .van-button--info {
    border-radius: 8px;
  }
}
.dayDemo {
  .regSha {
  }
}

.main {
  padding: 0 15px;
  padding-top: 54px;
  color: #2e3133;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  box-sizing: border-box;
  ::v-deep .van-calendar__confirm{
    height: 44px;
    font-size: 16px;
  }
  .formmain {
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 4px 4px 5px 0px rgba(51, 51, 51, 0.05);
    border-radius: 5px;
    .van-cell-group {
      background: transparent;
    }
    .group {
      ::v-deep .van-hairline--top-bottom:nth-of-type(1) {
        &::after {
          border-width: 0px !important;
        }
      }
      ::v-deep .van-hairline--top-bottom:nth-last-of-type(1) {
        &::after {
          border-width: 0px !important;
        }
      }
      box-shadow: none;
      ::v-deep .van-picker-column__item {

        font-size: 18px;
        color: rgba(70, 74, 76, 0.7);
        letter-spacing: 0;
        font-weight: 400;
      }
      ::v-deep .van-picker-column__item--selected {

        font-size: 20px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 500;
      }
      ::v-deep .van-picker__cancel {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 500;
      }
      ::v-deep .van-picker__confirm {

        font-size: 16px;
        color: #208fff;
        letter-spacing: 0;
        font-weight: 500;
      }

      // width:345px;
      margin: 0 auto;
      border-radius: 10px;
      background: #fff;
      ::v-deep .van-overlay {
        background: rgba(0, 0, 0, 0.2);
      }
    }
    .van-cell {
      background: #fff;
      color: #2e3133 !important;
      font-size: 16px !important;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .van-field__label {
      color: #2e3133 !important;
      font-size: 16px !important;
    }
    ::v-deep .van-field__error-message {
      text-align: right !important;
    }
  }
}
select {
  width: 100%;
  display: inline-block;
  position: relative;
  line-height: 30px;
  border-radius: 4px;
  height: 25px;
  color: #606266;
  border: 1px solid #dcdfe6;
}
.btnBox {
  margin-top: 50px;
  ::v-deep .van-button--info {
    border: none !important;
    outline: none !important;
  }
  .btn {
    margin: 0 auto;
    width: 305px;
    background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
    border-radius: 22px;

    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 700;
    z-index: 15;
    position: relative;
    .blueSha {
      z-index: 10;
      width: 266px;
      height: 34px;
      position: absolute;
      left: 50%;
      top: 68%;
      transform: translateX(-50%);
    }
  }
}
// 必选项*星号
.isRecessary > .van-field:before {
  position: absolute;
  left: 0.21333rem;
  color: #ee0a24;
  font-size: 0.37333rem;
  content: "*";
}
.isRecessary {
  ::v-deep .van-field__label {

    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 400;
  }
  ::v-deep .van-picker-column__item {

    font-size: 18px;
    color: rgba(70, 74, 76, 0.7);
    letter-spacing: 0;
    font-weight: 400;
  }
  ::v-deep .van-picker-column__item--selected {

    font-size: 20px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
  }
  ::v-deep .van-picker__cancel {

    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
  }
  ::v-deep .van-picker__confirm {

    font-size: 16px;
    color: #208fff;
    letter-spacing: 0;
    font-weight: 500;
  }
}
.main {
  ::v-deep .weekendRed {
    color: #ee0a24 !important;
  }
  ::v-deep .van-calendar__month-title {
    text-align: left;
    background: #f6f6f6 100%;
  }
}

.pri {
  // margin:0 auto;
  // text-align: center;
  margin-top: 10px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  // padding-left: 12px;
  span:nth-of-type(1) {

    font-size: 14px;
    color: #464a4c;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 400;
  }
  span:nth-of-type(2) {

    font-size: 14px;
    color: #208fff;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 700;
  }
  ::v-deep .van-checkbox__icon .van-icon {
    border-radius: 4px;
    border-color: #208fff;
  }
}
</style>
